<template>
  <div id="landing_redeem" class="column pt0">
    <Redeem2fa v-if="!authorized" @getOptStatus="getOtpStatus" @switchMode="switchMode()"/>
    <InternalStepStart @callNext="callNext()" v-if="step == 0 && authorized" />
    <InternalStepAmount
      v-if="step == 1"
      @callNext="(amount, userID) => withdrawInternal(amount, userID)"
    />
    <InternalStepConfirm
      v-if="step == 2"
      :whithdraw="internalWhithdraw"
      @callBackStep="callBackStep()"
      @callNext="callNext()"
    />

    <PinStep
      v-if="step == 3"
      :withdrawData="internalWhithdraw"
      @confirmWithdraw="(twoFA, pin) => confirmWithdrawInternal(twoFA, pin)"
      @cancelRedeem="(idTransactions) => cancelRedeem(idTransactions)"
    />

    <InternalStepFinish v-if="step == 4" :whithdraw="internalWhithdraw"/>
  </div>
</template>
<script>
import InternalStepStart from "./internal_steps/internalStepStart";
import InternalStepAmount from "./internal_steps/internalStepAmount";
import InternalStepConfirm from "./internal_steps/internalStepConfirm";
import PinStep from "./internal_steps/pinStep";
import InternalStepFinish from "./internal_steps/internalStepFinish";
import Redeem2fa from "./redeem_steps/Redeem2fa";

export default {
  props: ["openOrder"],
  data: () => ({
    step: 0,
    internalWhithdraw: "",
    authorized: "",
  }),
  components: {
    InternalStepStart,
    InternalStepAmount,
    InternalStepConfirm,
    PinStep,
    InternalStepFinish,
    Redeem2fa
  },
  created() {
    this.getOtpStatus();

    console.log(this.$options.propsData)

    console.log(this.openOrder)
  },
  methods: {
    callNext() {
      this.step++;
    },

    callBackStep() {
      this.step = this.step - 1;
    },

    async getOtpStatus() {
      let resp = await this.$store.dispatch("getOtpStatus");
      this.authorized = resp.data;
      this.$emit("updateOptStatus");
    },

    cancelRedeem(el){
      console.log('tao',el)
      this.$emit('cancelOpenWithdraws', el)
    },

    async withdrawInternal(amount, userID) {
      let withdraw = {
        amount: parseFloat(amount),
        memberUID: userID,
      };

      try {
        let resp = await this.$store.dispatch("postWithdrawInternal", withdraw);
        if (resp.status == 200) {
          this.internalWhithdraw = resp.data;
          console.log(this.internalWhithdraw);
          this.callNext();
        }
      } catch (e) {
        if (e.message == "TargetAddress not allowed") {
          this.notifyError(
            this.$t("msg.error_internal_member_not_found"),
            30 * 1000
          );
        } else if (e.message == "Fund in maintenance") {
          this.notifyError(this.$t("msg.fund_in_maintenance"), 30 * 1000);
        } else {
          this.notifyError(this.$t("msg.error_redeem"), 30 * 1000);
        }
      }
    },

    async confirmWithdrawInternal(twoFa, pin) {
      let type = "withdraw";

      let withdraw = {
        e2faCode: twoFa,
        id: this.internalWhithdraw.id,
        pinCode: pin,
      };

      try {
        let resp = await this.$store.dispatch("putWithdrawConfirm", withdraw)
        if(resp.status == 200){
            this.$store.dispatch("updateBluAccount");
            this.callNext();
        }
      } catch (e) {
        let error = String(e);
        let array = error.split(" ");
        let msgErro = "";

        array.shift();
        msgErro = array.join("_");

        this.notifyDanger(this.$t(`msg.${msgErro.toLowerCase()}`), 5000);
      }
    },

    switchMode() {
      this.$emit("switchMode");
    },
  },

  watch:{
    openOrder: function(){
      this.internalWhithdraw = this.openOrder;
      this.step = 2;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/private/services/InternalMain.vue